module.exports = __webpack_public_path__ + "static/media/3.a1c1e7a7.png";